module.exports = __webpack_public_path__ + "static/media/domecq_academy_white.f6f80a60.png";